var Opportunity = function () {

    var $body, $masonryBlocks;

    function init () {
        $body = $('body');
        $masonryBlocks = $('.masonry-block');
        registerEvents();
    }

    function discloseOpportunity (event) {
        event.preventDefault();

        $(this).parent().parent().toggleClass('open');
        $masonryBlocks.masonry({transitionDuration: 0});
    }

    function registerEvents () {
        $body.on('click.discloseOpportunity', '.opportunity-block a.header', discloseOpportunity);
    }

    return {
        init: init
    }

}();
